class ErrorMessages
  constructor: (@container) ->
    id = @container.data("id")
    @container.click ->
      child = $(".for_message_"+id+"_item")
      if child.css("display") == "none"
        child.show("slowly")
      else
        child.hide("slowly")
    if @container.hasClass("group-line")
      links = $(".for_message_"+id+" div.error_message")
    else
      links = @container.find("div.error_message")

    links.click ->
      url = $(this).data("url")
      $.get(url)

$(document).ready ->
  $("*[data-behavior=ErrorMessages]").each ->
    new ErrorMessages($(@))
